module.exports = __webpack_public_path__ + "img/logo_uniandrade.7a0fa515.png";